import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";
import { environment } from "../../../environments/environment";
import { customEmailValidator } from "../../shared/validators/custom-email.validator";

interface ValidateEmailResponse {
  valid: boolean;
}
@Component({
  selector: "app-email-forgot",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
  ],
  templateUrl: "./email-forgot.component.html",
  styleUrls: ["./email-forgot.component.scss"],
  providers: [MessageService],
})
export class EmailForgotComponent {
  loginForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService
  ) {
    this.loginForm = this.fb.group({
      email: ["", {
        validators: [Validators.required, Validators.email, customEmailValidator],
        updateOn: 'change'
      }],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) return;

    this.loading = true;
    const { email } = this.loginForm.value;
    localStorage.setItem("emailVerifyForgotPassword", email);
    this.http
      .post<ValidateEmailResponse>(
        `${environment.apiUrlMSCommunicationService}/mailer/validate-email`,
        { email, typeUser: "admin" }
      )
      .subscribe({
        next: (res) => {
          this.messageService.add({
            severity: "success",
            summary: "Solicitud recibida",
            detail: "Si el correo está registrado, recibirás instrucciones.",
          });
          this.loading = false;
          
          if (res.valid) {
            setTimeout(() => {
              this.router.navigate(["/forgot-password"]);
            }, 2000);
          }
        },
        error: (err) => {
          this.loading = false;
          
          const isTechnicalError = err.status >= 500 || 
                                   err.status === 0 || 
                                   err.name === 'TimeoutError' ||
                                   !err.status;
          
          if (isTechnicalError) {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Ups, se presentó un error, inténtalo de nuevo.",
            });
          } else {
            this.messageService.add({
              severity: "success",
              summary: "Solicitud recibida",
              detail: "Si el correo está registrado, recibirás instrucciones.",
            });
          }
        },
      });
  }
  goBack() {
    this.router.navigate(["/"]);
  }
}
